<template>
  <div
    :class="{
      Navbar: true,
      NavbarTwo: isMode == 'leftHide',
      NavbarThree: isMode == 'rightHide',
    }"
  >
    <div class="rightNav">
      <!-- 登录信息骨架屏 -->
      <div v-show="$store.state.isapp == 0" class="skeleton-head"></div>
      <!-- 用户信息 -->
      <div
        class="loginTrue"
        v-show="$store.state.isapp == 1 && $store.state.isLogin == 1"
      >
        <div
          class="clearBox"
          v-show="$route.name == 'notice'"
          @click="noticeUp"
        >
          <div class="clearF">一键已读</div>
          <svg-btn class="icon" icon-class="icon-gfans-clear"></svg-btn>
        </div>
        <el-badge
          :hidden="$store.state.notesTotal == 0"
          :value="$store.state.notesTotal"
          :max="99"
          class="item"
        >
          <svg-btn
            @click="$router.push('/notice')"
            class="icon"
            icon-class="icon-notes"
          ></svg-btn>
        </el-badge>
        <ClickPop>
          <div class="headImg" v-if="$store.state.userInfo.logo">
            <el-image
              :src="$store.state.userInfo.logo"
              fit="cover"
              class="headImg"
            >
              <img
                width="40"
                height="40"
                slot="error"
                class="error-headImg"
                :src="$utils.getPng('icon-gfans-defaultHead')"
              />
            </el-image>
          </div>
          <div slot="content" class="userCheck">
            <div
              class="check"
              @click="toUrl(item.id)"
              v-for="(item, index) in checkList"
              :key="index"
            >
              <span>{{ item.name }}</span>
            </div>
          </div>
        </ClickPop>
      </div>
      <!-- 注册登录 -->
      <div
        class="loginFalse"
        v-show="$store.state.isapp == 1 && $store.state.isLogin == 0"
      >
        <div class="primaryBtn bt1" @click="toLogin()">登 录</div>
        <div class="tcBtn bt2" @click="toLogin('register')">注 册</div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkRed } from '@/axios/notice'
import {
  loginOutAPI,
  userInfoAPI,
  getMsgNumAPI,
  getCollectNumAPI,
} from '@/axios/common'
import ClickPop from '@/components/ClickPop/index'
import { eventBus } from '@/utils/event-bus'
export default {
  components: {
    ClickPop,
  },
  props: {
    isMode: {
      type: String,
      default: 'none',
    },
  },
  data() {
    return {
      checkList: [
        {
          id: 1,
          name: '个人主页',
        },
        {
          id: 2,
          name: '我的订阅',
        },
        {
          id: 3,
          name: '我的收藏',
        },
        {
          id: 4,
          name: '前往创作中心',
        },
        {
          id: 5,
          name: '前往Feemoo',
        },
        {
          id: 6,
          name: '前往CloudMaster',
        },
        {
          id: 7,
          name: '账号设置',
        },
        {
          id: 8,
          name: '退出登录',
        },
      ],
    }
  },
  mounted() {
    // 监听更新用户数据事件
    eventBus.$on('getUser', () => {
      this.getUser()
    })
    // 监听更新消息数据事件
    eventBus.$on('getMsg', () => {
      this.getMsg()
    })
    // 监听更新收藏消息事件
    eventBus.$on('getCollect', () => {
      this.getCollect()
    })
    //之后在登录以后刷新页面需要重新获取用户信息，没有登录不需要调用，登录之后会在router里面调用第一次
    if (this.$store.state.isLogin == 1) {
      this.getCollect()
      this.getMsg()
      this.getUser()
    }
    document.addEventListener('visibilitychange', this.handleVisiable)
  },
  beforeDestroy() {
    eventBus.$off('getUser')
    eventBus.$off('getMsg')
    eventBus.$off('getCollect')
    document.removeEventListener('visibilitychange', this.handleVisiable)
  },
  methods: {
    //获取用户信息
    async getUser() {
      try {
        let res = await userInfoAPI({
          version_type: 2,
        })
        if (res.status == 1) {
          this.$store.commit('setAttr', {
            name: 'userInfo',
            val: res.data,
          })
          this.$store.commit('setAttr', {
            name: 'isLogin',
            val: 1,
          })
          localStorage.setItem('gfansLogin', 1)
          this.$store.commit('setAttr', {
            name: 'isapp',
            val: 1,
          })
          this.$store.commit('setAttr', {
            name: 'iamvip',
            val: res.data.iamvip,
          })
          this.$store.commit('setAttr', {
            name: 'isDownloadStyles',
            val: res.data.isDownloadStyle,
          })
        }
      } catch (error) {}
    },
    //获取消息数
    async getMsg() {
      try {
        let res = await getMsgNumAPI()
        if (res.status == 1) {
          this.$store.commit('setAttr', {
            name: 'notesTotal',
            val: res.msg.total,
          })
          this.$store.commit('setAttr', {
            name: 'msgData',
            val: res.msg.list,
          })
        }
      } catch (error) {}
    },
    //获取收藏消息数
    async getCollect() {
      try {
        let res = await getCollectNumAPI()
        if (res.status == 1) {
          this.$store.commit('setAttr', {
            name: 'collectTotal',
            val: Number(res.data.total),
          })
          this.$store.commit('setAttr', {
            name: 'collectPost',
            val: Number(res.data.post),
          })
          this.$store.commit('setAttr', {
            name: 'collectVideo',
            val: Number(res.data.video),
          })
        }
      } catch (error) {}
    },
    //多标签同步登录状态
    handleVisiable(e) {
      switch (e.target.visibilityState) {
        case 'prerender':
          // console.log('网页预渲染，内容不可见')
          break
        case 'hidden':
          // console.log('内容不可见，处理后台、最小化、锁屏状态')
          break
        case 'visible':
          let isLogin = localStorage.getItem('gfansLogin')
          if (isLogin && isLogin == 1) {
            //缓存提示登录了,但是vuex没更新的情况
            if (this.$store.state.isLogin == 0) {
              this.getUser()
              eventBus.$emit('upHotList')
            }
            this.getCollect()
            this.getMsg()
          } else {
            localStorage.removeItem('platfro')
            localStorage.removeItem('gfansLogin')
            localStorage.removeItem('authtoken1')
            localStorage.removeItem('noticeActive')
            this.$utils.clearCookie(this.$glb.fmCookieName)
            this.$store.commit('setAttr', { name: 'userInfo', val: {} })
            this.$store.commit('setAttr', { name: 'isLogin', val: 0 })
            this.$store.commit('setAttr', { name: 'isPage', val: 1 })
            this.$store.commit('setAttr', { name: 'isapp', val: 1 })
            this.$store.commit('setAttr', { name: 'collectTotal', val: 0 })
            this.$store.commit('setAttr', { name: 'collectPost', val: 0 })
            this.$store.commit('setAttr', { name: 'collectVideo', val: 0 })
            eventBus.$emit('upHotList')
            const excludedRoutes = ['home', 'jx', 'vd', 'tab']
            // 如果当前路由不在排除列表中，跳转到 /discover
            if (!excludedRoutes.includes(this.$route.name)) {
              this.$router.push({ path: '/discover' })
            }
            this.scrollToTop()
          }
          break
      }
    },
    //一键已读
    noticeUp: _.debounce(
      function () {
        checkRed()
          .then(res => {
            if (res.status == 1) {
              this.getMsg()
              eventBus.$emit('clearNotice')
              this.$toast(res.msg, 1)
            }
          })
          .catch(error => {})
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    toUrl(id) {
      const openExternalUrl = url => {
        setTimeout(() => window.open(url, '_blank'), 200)
      }
      const pushExternalUrl = (url, num) => {
        //切换左侧菜单选中
        eventBus.$emit('checkLeftMenu', num)
        this.$router.push(url)
      }
      // 使用对象映射替代大部分条件判断
      const routeMap = {
        1: () =>
          this.$router.push({
            name: 'user',
            params: { uid: this.$store.state.userInfo.usercode },
          }),
        2: () => pushExternalUrl('/subscribe', 1),
        3: () => pushExternalUrl('/collect', 2),
        4: () =>
          openExternalUrl(
            this.$glb.upJmdyhUrl +
              `/subscribe?platfro=${localStorage.getItem('platfro')}`
          ),
        5: () => openExternalUrl(this.$glb.feemooUrl + '/drive'),
        6: () => openExternalUrl(this.$glb.cdMasterUrl + '/homepage'),
        7: () => openExternalUrl(this.$glb.feemooUrl + '/account'),
        8: () => this.loginOut(),
      }

      // 执行对应处理函数
      routeMap[id]?.()
    },
    //退出登录
    loginOut() {
      loginOutAPI()
        .then(res => {
          localStorage.removeItem('platfro')
          localStorage.removeItem('gfansLogin')
          localStorage.removeItem('authtoken1')
          localStorage.removeItem('noticeActive')
          this.$utils.clearCookie(this.$glb.fmCookieName)
          this.$store.commit('setAttr', { name: 'userInfo', val: {} })
          this.$store.commit('setAttr', { name: 'isLogin', val: 0 })
          this.$store.commit('setAttr', { name: 'isPage', val: 1 })
          this.$store.commit('setAttr', { name: 'isapp', val: 1 })
          this.$store.commit('setAttr', { name: 'collectTotal', val: 0 })
          this.$store.commit('setAttr', { name: 'collectPost', val: 0 })
          this.$store.commit('setAttr', { name: 'collectVideo', val: 0 })
          eventBus.$emit('upHotList')
          if (this.$route.name == 'jx' || this.$route.name == 'vd') {
            this.$router.push(this.$route.path)
            eventBus.$emit('upDetailList')
          } else {
            this.$router.push({ path: '/discover' })
            eventBus.$emit('upHomeList')
          }
          this.scrollToTop()
        })
        .catch(err => {})
    },
    // 回到顶部
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    toLogin(row) {
      eventBus.$emit('showLogin', {})
      // let path = this.$route.path.toString().slice(1)
      // const from = 'gfans'
      // const fromUrl = this.$glb.jmdyhUrl + `/${path}`
      // const encodedFrom = encodeURIComponent(from)
      // const encodedFromUrl = encodeURIComponent(fromUrl)
      // if (row == 'register') {
      //   window.location.href =
      //     this.$glb.feemooUrl +
      //     `/login?path=drive&tab=2&from=${encodedFrom}&fromUrl=${encodedFromUrl}`
      // } else {
      //   window.location.href =
      //     this.$glb.feemooUrl +
      //     `/login?from=${encodedFrom}&fromUrl=${encodedFromUrl}`
      // }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
